<div class="u-shadow-mini" style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini c-portlet-gap">
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span>
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					>
						<img class="downloadIcon" src="../../../../../assets/images/Download_Icon.svg" />
					</a>
				</span>
			</div>
		</div>

		<div class="metrics-header" *ngIf="hasData">
			<div class="sem-conversion-metrics" *ngFor="let metric of metricObject">
				<div class="conversion-metrics">
					<div class="metric-name" appTooltip [attr.title]="metric?.tooltip" [options]="tooltipOptions">
						{{ metric.name }}
					</div>
					<div class="metric-value">{{ metric.value }}</div>
				</div>
			</div>
		</div>

		<div [ngClass]="sectionclass != '' ? sectionclass : 'analytics-portlet-content'">
			<div class="o-stack o-stack--nowrap o-stack--center">
				<div class="donut-chart-container" *ngFor="let config of multichartconfigurations; let i = index">
					<div class="conversions_legend">CONVERSIONS</div>
					<div class="outer-div" *ngIf="hasData">
						<div
							class="inner-div"
							[ngClass]="donutOptions.biggerDonut ? 'bigger-donut' : ''"
							*ngFor="let donut of donutArray; let j = index"
						>
						<app-generic-chart
							id="device-id-{{ i }}"
							[configuration]="config"
							[colorPalette]="colorPalette"
							[data]="donutArray[j]"
						>
						</app-generic-chart>
							<div class="donut-value" [ngClass]="donutOptions.biggerDonut ? 'bigger-donut-value' : ''">
								{{ donutArray[j][0].percent }}%
							</div>

							<div class="conversions_lable_tooltip {{donutArray[j][0]?.tooltip }}">
								<div
									class="donut-title"
									*ngIf="!donutOptions?.biggerDonut"
									appTooltip
									[attr.title]="donutArray[j][0]?.tooltip"
									data-size="small"
									[options]="tooltipOptions"
								>
									{{ donutArray[j][0]?.title }}
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="!hasData" class="no-data-device">
						<div class="no-data-text">No Data Available</div>
					</div>
				</div>
			</div>
		</div>
		<div [ngClass]="sectionclass != '' ? sectionclass : 'conversion-table-widget'" *ngIf="hasData">
			<ngx-datatable
				class="datatable"
				[rows]="tableData"
				[columns]="columns"
				[sortType]="'single'"
				[columnMode]="'force'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="'auto'"
				[limit]="10"
				[reorderable]="reorderable"
			>
			</ngx-datatable>
		</div>
	</div>
</div>
